import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const validateGroupThunk = createAsyncThunk(
    `ValidateGroupSlice/validateGroup`,
    async ({ participantId, flowId }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const url = `Participant/${participantId}/validate-groups/${flowId}`;

        const { data } = await conciergeApiClient.get(url, { headers });

        return data;
    }
);

const initialState = {
    loadingGroupValidation: false,
    groupValidationError: false,
};

const ValidateGroupSlice = createSlice({
    name: 'ValidateGroups',
    initialState,
    reducers: {
        resetGroupValidationData: (state) => {
            state.loadingGroupValidation = false;
            state.groupValidationError = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(validateGroupThunk.pending, (state) => {
            state.loadingGroupValidation = true;
            state.groupValidationError = false;
        });
        builder.addCase(validateGroupThunk.fulfilled, (state, action) => {
            state.loadingGroupValidation = false;
            state.groupValidationError = false;
        });
        builder.addCase(validateGroupThunk.rejected, (state) => {
            state.loadingGroupValidation = false;
            state.groupValidationError = true;
        });
    },
});

export const { resetGroupValidationData } = ValidateGroupSlice.actions;
export default ValidateGroupSlice.reducer;